import type { PublicCollectionResponse } from '@mrb91002/shared-types'
import { API_BASE } from '../config'

export async function fetchPublicCollection(
  collectionId: string,
  lastKey: Record<string, unknown> | string | null = null,
): Promise<PublicCollectionResponse> {
  let url = `${API_BASE}/collections/${collectionId}`
  if (lastKey) {
    const lastKeyStr = typeof lastKey === 'string' ? lastKey : JSON.stringify(lastKey)
    url += `?lastKey=${encodeURIComponent(lastKeyStr)}`
  }
  const response = await fetch(url)
  if (!response.ok) throw new Error('Failed to fetch collection')
  return response.json() as Promise<PublicCollectionResponse>
}
